import { StepLayout } from 'components/StepLayout/StepLayout';
import React, { FC } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { SelectCategoryStepOptions } from './components/SelectCategoryStepOptions';
import { BI_ACTION_NAME, BI_STEP_NAME } from 'config/bi';
import { biEvents } from 'api/bi-events';
import { StepId } from 'config/steps';
import { useAppStore } from 'stores/appStore';

export const SelectCategoryStep: FC = () => {
  const { t } = useTranslation();
  const selectedCategory = useAppStore((state) => state.selectedCategory);

  return (
    <StepLayout
      title={t('select-category-step.title')}
      description={t('select-category-step.description')}
      nextButtonProps={{ label: t('select-category-step.actions.primary-button'), disabled: !selectedCategory }}
      onBack={() => {
        biEvents.actionClicked({
          screenName: BI_STEP_NAME[StepId.SelectCategory],
          action: BI_ACTION_NAME.BACK,
        });
      }}
      onNext={() => {
        biEvents.actionClicked({
          screenName: BI_STEP_NAME[StepId.SelectCategory],
          action: BI_ACTION_NAME.CONTINUE,
          value: selectedCategory,
        });
      }}
    >
      <SelectCategoryStepOptions />
    </StepLayout>
  );
};
